<template>
  <div
    v-if="loaded"
    class="page"
  >
    <div class="page__sidebar">
      <registry-request-side-bar
        v-if="showSideBar"
        :counters="sidebarSummary"
        @click-add-filter="onClickAddFilter"
        @update-option="onClickUpdateFilter($event)"
        @updateSummary="loadSidebarSummary"
      />
      <registry-case-side-bar
        v-if="!showSideBar"
        ref="studySideBar"
        :counters="sidebarSummary"
        @click-add-filter="onClickAddFilter"
        @update-option="onClickUpdateFilter($event)"
        @updateSummary="loadSidebarSummary"
      />
    </div>
    <div class="page__main">
      <router-view
        ref="mainContent"
        class="page__main-content"
        @updateSummary="loadSidebarSummary"
        @formUpdated="updateLastModified"
      />
    </div>
  </div>
</template>

<script>
import RegistryRequestResource from '@/modules/RegistryModule/services/registryRequestResource'
import registrySideBarStore from './sideBar/request/registryRequestSideBarStore'
import studySideBarStore from './sideBar/case/registryCaseSideBarStore'
import RegistryRequestSideBar from './sideBar/request/RegistryRequestSideBar'
import RegistryCaseSideBar from './sideBar/case/RegistryCaseSideBar'
import customConfigResource from '@/api/resources/ui/CustomConfigResource'
import CaseServices from '@/modules/RegistryModule/services/registryCaseServices'
import { caseState } from '@/api/resources/entityState/case-state'
import { requestState } from '@/api/resources/entityState/request-state'
import { registryStore } from '@/modules/RegistryModule/store/registry.store'

export default {
    name: 'RegistryIndex',
    components: {
        RegistryRequestSideBar,
        RegistryCaseSideBar
    },
    beforeRouteUpdate(to, from, next) {
        this.previousRoute = from.name
        next()
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.previousRoute = from.name
        })
    },
    data() {
        return {
            loaded: false,
            sidebarSummaryInterval: null,
            sidebarSummary: null,
            showSideBar: true,
            storeNameModal: 'registryModalsState',
            modalUiComponent: 'uicomponent.registry.modalconfig',
            previousRoute: null
        }
    },
    computed: {
        routeName() {
            return this.$route.name
        },
        labId() {
            return this.$store.getters.labId
        }
    },
    watch: {
        routeName() {
            this.$nextTick(async () => {
                await this.checkRoute()
                this.$_cleanSearchState()
            })
        },
        loadSidebarSummary() {
            this.loadSidebarSummary()
        }
    },
    beforeCreate() {
        registryStore.register()
    },
    async created() {
        this.sidebarSummary = { 'registryRequested': '-', 'registryRequestsLocked': '-', 'draft': '-' }
        this.sidebarSummaryInterval = this.$_setSummaryInterval(this.loadSidebarSummary)

        this.showSideBar = !(this.$route.name === 'newCase' || this.$route.name === 'registryEditCase' || this.$route.name === 'caseGrid')
        await this.checkRoute()
    },
    beforeDestroy() {
        if (this.sidebarSummaryInterval !== null) {
            clearInterval(this.sidebarSummaryInterval)
        }
        this.cleanSearchStateGlobalMixin()
        registryStore.unregister()
    },
    methods: {
        async loadModalConfiguration() {
            const customConfig = await customConfigResource.get(this.modalUiComponent)
            if (customConfig) {
                await this.$_setModalConfirmationState(this.storeNameModal, customConfig.config)
            }
        },
        async loadSidebarSummary() {
            if (!this.showSideBar) {
                this.sidebarSummary = await CaseServices.caseSummary(this.labId)
            } else {
                this.sidebarSummary = await RegistryRequestResource.requestsSummary(this.labId)
            }
        },
        onClickAddFilter() {
            if (this.$refs.mainContent.onSideBarClickAddFilter) {
                this.$refs.mainContent.onSideBarClickAddFilter()
            }
        },
        onClickUpdateFilter(option) {
            if (this.$refs.mainContent.onSideBarClickUpdateFilter) {
                this.$refs.mainContent.onSideBarClickUpdateFilter(option)
            }
        },
        selectSidebarOption(sidebar) {
            let sidebarOption = null
            if (!this.previousRoute && this.$route.meta.isFormView) {
                sidebar.selectFallbackOption()
            } else if (this.$route.params.fromForm || this.$route.meta.isFormView) {
                sidebarOption = sidebar.state.selectedOption?.id
            } else if (this.$route.meta.isGridView) {
                sidebarOption = this.getSideBarOption(sidebar, this.$route.params.sidebarOption)
            }
            if (sidebarOption) {
                const option = sidebar.findOptionById(sidebarOption)
                sidebar.setSelectedOption(option)
            } else {
                sidebar.selectFallbackOption()
            }
        },
        getSideBarOption(sidebar, sidebarOptionFromRoute) {
            let sideBarOption = null
            const sidebarState = sidebar.state
            if (sidebarOptionFromRoute) {
                sideBarOption = sidebarOptionFromRoute
            } else if (sidebarState.config.defaultOptionId) {
                sideBarOption = sidebarState.config.defaultOptionId
            }
            return sideBarOption
        },
        async loadConfig(sidebar) {
            try {
                await Promise.all([
                    sidebar.loadConfig(),
                    sidebar.loadCustomOptions(),
                    this.loadModalConfiguration(),
                    this.showSideBar ? requestState.loadStates() : caseState.loadStates()
                ])
                this.selectSidebarOption(sidebar)
            } finally {
                this.loaded = true
            }
        },
        updateLastModified() {
            this.$refs.studySideBar.updateLastModified()
        },
        async checkRoute() {
            if (this.$route.name === 'caseGrid' || this.$route.name === 'newCase' || this.$route.name === 'registryEditCase') {
                this.showSideBar = false
                await this.loadConfig(studySideBarStore)
            } else {
                this.showSideBar = true
                await this.loadConfig(registrySideBarStore)
            }
        }
    }
}

</script>
